'use client';
import React, { useEffect, useState } from 'react';
import { getMuted, setMuted } from '@/lib/gameStore';

export default function MuteToggle() {
  const [muted, setMutedState] = useState(false);

  useEffect(() => {
    setMutedState(getMuted());
  }, []);

  const toggle = () => {
    const next = !muted;
    setMutedState(next);
    setMuted(next);
  };

  return (
    <button
      onClick={toggle}
      className="btn-ghost px-3 py-2 text-sm flex items-center gap-1.5"
      title={muted ? 'Unmute sounds' : 'Mute sounds'}
      aria-label={muted ? 'Unmute sounds' : 'Mute sounds'}
    >
      <span className="text-base">{muted ? '🔇' : '🔊'}</span>
    </button>
  );
}